import { render, staticRenderFns } from "./RegistroNomina.vue?vue&type=template&id=7b6ba69e&"
import script from "./RegistroNomina.vue?vue&type=script&lang=js&"
export * from "./RegistroNomina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports